export default __webpack_public_path__ + "static/media/layer03.b882888e.png";